import apiWrapper from 'Helpers/apiWrapper'
import extractApiData from 'Helpers/extractApiData'
import { encodeParams } from 'mailup-react-helpers'

const endpoints = ((baseURL) => {
  return {
    getArrayOfListsByIdSource: (idSource) =>
      `${baseURL}/api/sources/${idSource}/lists`,
    getArrayOfSourcesByIdList: (idList) =>
      `${baseURL}/api/lists/${idList}/sources?withShared=true&t=${new Date().getTime()}`,
    getCampaignsByIdSource: (idSource) =>
      `${baseURL}/api/sources/${idSource}/campaigns`,
    setArrayOfListsByIdSource: (idSource) =>
      `${baseURL}/api/sources/${idSource}/lists`,
    getListOfCampaigns: (idList, params) =>
      `${baseURL}/api/lists/${idList}/campaigns?${encodeParams(params)}`,
    getEmailCampaign: (idCampaign) =>
      `${baseURL}/api/email/campaigns/${idCampaign}`,
    getMapiCampaign: (idCampaign) =>
      `${baseURL}/api/mapi/campaigns/${idCampaign}`,
    getCampaignHistory: (idCampaign, params) =>
      `${baseURL}/api/campaigns/${idCampaign}/history?${encodeParams(params)}`,
    putCampaign: (idList, idCampaign) =>
      `${baseURL}/api/lists/${idList}/email/campaigns/${idCampaign}`,
    postExecuteTest: (idCampaign) =>
      `${baseURL}/api/mapi/campaigns/${idCampaign}/execute/test`,
    deleteCampaign: (idCampaign) => `${baseURL}/api/campaigns/${idCampaign}`,
    putMapiCampaign: (idList, idCampaign) =>
      `${baseURL}/api/lists/${idList}/mapi/campaigns/${idCampaign}`,
    insertEmailCampaign: (idList) =>
      `${baseURL}/api/lists/${idList}/email/campaigns`,
    updateEmailCampaign: (idList, idCampaign) =>
      `${baseURL}/api/lists/${idList}/email/campaigns/${idCampaign}`,
    getEmailTemplatePreview: (idTemplate, params) =>
      `${baseURL}/api/email/templates/${encodeURIComponent(
        idTemplate
      )}/preview?${encodeParams(params)}`
  }
})(process.env.CAMPAIGNS_BUILDER_API_URL)

export const beCampaignsBuilderGetArrayOfListsByIdSource = (idSource) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getArrayOfListsByIdSource(idSource)
  }).then(({ data }) => {
    return data
  })
}

export const beCampaignsBuilderGetArrayOfSourcesByIdList = (idList) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getArrayOfSourcesByIdList(idList)
  }).then(({ data }) => {
    return data
  })
}

export const beCampaignsBuilderGetCampaignsByIdSource = (idSource) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getCampaignsByIdSource(idSource)
  }).then(({ data }) => {
    return data
  })
}

export const beCampaignsSetArrayOfListsByIdSource = (idSource, data) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.setArrayOfListsByIdSource(idSource),
    data: JSON.stringify(data)
  }).then(({ data }) => {
    return data
  })
}

export const beCampaignsBuilderGetLisOfCampaigns = (idList, params) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getListOfCampaigns(idList, params)
  }).then(({ data }) => {
    return data
  })
}

export const beCampaignsBuilderGetEmailCampaignById = (idCampaign) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getEmailCampaign(idCampaign)
  }).then(({ data }) => {
    return data
  })
}

export const beCampaignsBuilderGetMapiCampaign = (idCampaign) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getMapiCampaign(idCampaign)
  }).then(({ data }) => {
    return data
  })
}

export const beCampaignsBuilderGetCampaignHistory = (idCampaign, params) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getCampaignHistory(idCampaign, params)
  }).then(({ data }) => {
    return data
  })
}

export const beCampaignsBuilderPutCampaign = (idList, idCampaign, params) => {
  return apiWrapper({
    method: 'put',
    url: endpoints.putCampaign(idList, idCampaign),
    data: JSON.stringify(params)
  }).then(({ data }) => {
    return data
  })
}

export const beCampaignsPostExecuteTest = (idCampaign) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.postExecuteTest(idCampaign)
  }).then(({ data }) => {
    return data
  })
}

export const beCampaignsDeleteCampaigns = (idCampaign) => {
  return apiWrapper({
    method: 'delete',
    url: endpoints.deleteCampaign(idCampaign)
  }).then(({ data }) => {
    return data
  })
}

export const beCampaignsBuilderPutMapiCampaign = (
  idList,
  idCampaign,
  params
) => {
  return apiWrapper({
    method: 'put',
    url: endpoints.putMapiCampaign(idList, idCampaign),
    data: JSON.stringify(params)
  }).then(({ data }) => {
    return data
  })
}

export const beCampaignsBuilderInsertEmailCampaign = (idList, data) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.insertEmailCampaign(idList),
    data: JSON.stringify(data)
  }).then(({ data }) => {
    return data
  })
}

export const beCampaignsBuilderUpdateEmailCampaign = (
  idList,
  idCampaign,
  data
) => {
  return apiWrapper({
    method: 'put',
    url: endpoints.updateEmailCampaign(idList, idCampaign),
    data: JSON.stringify(data)
  }).then(({ data }) => {
    return data
  })
}

export const beCampaignsBuilderApiGetEmailTemplatePreview = (
  idTemplate,
  params
) => {
  const url = endpoints.getEmailTemplatePreview(idTemplate, params)
  return apiWrapper({
    method: 'get',
    url
  }).then(extractApiData)
}
